
    import Vue from "vue";
    import Component from "vue-class-component";
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
    import { Prop } from "vue-property-decorator";
    import { CertificateDetailsModel, CertificatesClient } from "@/api-client";
    import OfficialSignature from "@/features/shared/components/OfficialSignature.vue";
    import CertificateStatusBadge from "@/features/shared/components/CertificateStatusBadge.vue";
    import ButtonWithConfirm from "@/features/shared/components/ButtonWithConfirm.vue";
    import QrCode from "@/components/QrCode.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    import AdditionalInfoButton from "@/features/shared/components/AdditionalInfoButton.vue";
    import PopoverInfo from "@/components/PopoverInfo.vue";
    import Files from "@/components/Files.vue";
    import DocumentPersonalInfo from "@/features/shared/components/DocumentPersonalInfo.vue";

    @Component({
        components: {
            AdditionalInfoButton,
            OfficialSignature,
            SectionPageHeading,
            HeadingGroup,
            ButtonWithConfirm,
            QrCode,
            CertificateStatusBadge,
            LabelOptional,
            Files,
            PopoverInfo,
            DocumentPersonalInfo
        },
    })
    export default class CertificateDetailsContent extends Vue {
        @Prop({ required: true })
        id!: string;

        @Prop()
        isOfficial!: boolean;

        @Prop()
        details?: CertificateDetailsModel;

        certificate!: CertificateDetailsModel;

        dataLoaded = false;

        async getDownloadUrl(fileId: string): Promise<string> {
            return (await new CertificatesClient().downloadFile(this.id, fileId)).url;
        }
        
        async created() {
            if (this.details) {
                this.certificate = this.details;
            }
            else {
                this.certificate = await new CertificatesClient().details(this.id);
            }

            this.dataLoaded = true;

            this.$watch(
                () => this.details,
                (details) => (this.certificate = details!)
            );
        }
    }
